/**
 * import { loadStripe } from '@stripe/stripe-js';
 * import axios from 'axios';
 * import React, { useEffect, useState } from 'react';
 * import { Link } from 'react-router-dom';
 * import FadeLoader from 'react-spinners/FadeLoader';
 * import error from '../assets/error.png';
 * import success from '../assets/success.png';
 *
 * const load = async() => {
 *   return await  loadStripe('pk_test_51QtoA0PctDBXz6AxE7yhxhIVU9HAjNq849nuDs1ddmngjhEmkUfiLQ5XBjrde3qDZCV0xCOCuO0UpMZ7AymeI8Gb00Ctm1DkjR');
 * }
 *
 *
 * const ConfirmOrder = () => {
 *
 *   const [loader, setLoader] = useState(true);
 *   const [stripe, setStripe] = useState('');
 *   const [message, setMessage] = useState(null);
 *
 *   useEffect(()=>{
 *     if (!stripe) {
 *       return
 *     }
 *     const clientSecret = new URLSearchParams(window.location.search).get('payment_intent_client_secret');
 *     if (!clientSecret) {
 *       return
 *     }
 *     stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
 *       switch (paymentIntent.status) {
 *         case 'succeeded':
 *           setMessage('Payment was successful');
 *           break
 *         case 'processing':
 *           setMessage('Your payment is being processed');
 *           break
 *         case 'requires_payment_method':
 *           setMessage('Your payment was declined');
 *           break
 *         default :
 *           setMessage('Something went wrong');
 *       }
 *     })
 *   },[stripe])
 *
 *   const get_loader = async() => {
 *     const tempStripe = await load()
 *     setStripe(tempStripe);
 *   }
 *
 *   useEffect(()=>{
 *     get_loader()
 *   },[])
 *
 *   const update_payment = async() => {
 *     const orderId = localStorage.getItem('orderId')
 *     try {
 *       const {data} = await axios.get(`http://localhost:5000/api/order/confirm/${orderId}`)
 *       console.log(data)
 *       localStorage.removeItem('orderId')
 *       setLoader(false)
 *     } catch (error) {
 *       console.log(error.response.data)
 *     }
 *   }
 *
 *   useEffect(()=>{
 *     if (message==='succeeded') {
 *       update_payment()
 *    }
 *   },[message])
 *
 *   return (
 *     <div className='w-screen h-screen flex justify-center items-center flex-col gap-4'>
 *         {
 *           (message==='Something went wrong' || message==='processing')
 *           ? <> <img src={error} alt="error" />
 *           <Link className='px-5 py-2 bg-red-500 rounded-sm text-white' to={'/dashboard/my_orders'}>Back to BashBoard</Link>
 *             </>
 *           : message ==='succeeded'? loader ? <FadeLoader/> : <> <img src={success} alt="success" />
 *           <Link className='px-5 py-2 bg-green-500 rounded-sm text-white' to={'/dashboard/my_orders'}>Back to BashBoard</Link>
 *             </> :<FadeLoader/>
 *         }
 *     </div>
 *   )
 * }
 *
 * export default ConfirmOrder
 *
 * @format
 */

import { loadStripe } from "@stripe/stripe-js";
import axios from "axios";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import FadeLoader from "react-spinners/FadeLoader";
import error from "../assets/error.png";
import success from "../assets/success.png";

const ConfirmOrder = () => {
  const [loader, setLoader] = useState(true);
  const [stripe, setStripe] = useState(null);
  const [message, setMessage] = useState(null);

  const { t } = useTranslation();

  useEffect(() => {
    const loadStripeInstance = async () => {
      const stripeInstance = await loadStripe(
        "pk_test_51QtoA0PctDBXz6AxE7yhxhIVU9HAjNq849nuDs1ddmngjhEmkUfiLQ5XBjrde3qDZCV0xCOCuO0UpMZ7AymeI8Gb00Ctm1DkjR",
      );
      setStripe(stripeInstance);
    };
    loadStripeInstance();
  }, []);

  useEffect(() => {
    if (!stripe) return;

    const clientSecret = new URLSearchParams(window.location.search).get(
      "payment_intent_client_secret",
    );
    if (!clientSecret) {
      setMessage(`${t("Something went wrong")}`);
      setLoader(false);
      return;
    }

    stripe
      .retrievePaymentIntent(clientSecret)
      .then(({ paymentIntent }) => {
        switch (paymentIntent?.status) {
          case "succeeded":
            setMessage(`${t("succeeded")}`);
            break;
          case "processing":
            setMessage(`${t("Your payment is being processed")}`);
            setLoader(false);
            break;
          case "requires_payment_method":
            setMessage(`${t("Your payment was declined")}`);
            setLoader(false);
            break;
          default:
            setMessage(`${t("Something went wrong")}`);
            setLoader(false);
        }
      })
      .catch((error) => {
        //  console.error('Error retrieving payment intent:', error);
        setMessage(`${t("Something went wrong")}`);
        setLoader(false);
      });
  }, [stripe, t]);

  useEffect(() => {
    const updatePayment = async () => {
      const orderId = localStorage.getItem("orderId");
      if (!orderId) {
        setMessage(`${t("Something went wrong")}`);
        setLoader(false);
        return;
      }

      try {
        await axios.get(
          `${process.env.REACT_APP_SERVER_URL}/api/order/confirm/${orderId}`,
        );
        // console.log(data);
        localStorage.removeItem("orderId");
        setLoader(false);
      } catch (error) {
        //console.error('Error updating payment:', error.response?.data || error.message);
        setMessage(`${t("Something went wrong")}`);
        setLoader(false);
      }
    };

    if (message === `${t("succeeded")}`) {
      updatePayment();
    }
  }, [message, t]);

  return (
    <div className='w-screen h-screen flex justify-center items-center flex-col gap-4'>
      {message === `${t("Something went wrong")}` ||
      message === `${t("Your payment was declined")}` ? (
        <>
          <img src={error} alt={t("Error")} />
          <Link
            className='px-5 py-2 bg-red-500 rounded-sm text-white'
            to='/dashboard/my_orders'
          >
            {t("Back to Dashboard")}
          </Link>
        </>
      ) : message === `${t("succeeded")}` ? (
        loader ? (
          <FadeLoader />
        ) : (
          <>
            <img src={success} alt={t("Success")} />
            <Link
              className='px-5 py-2 bg-green-500 rounded-sm text-white'
              to='/dashboard/my_orders'
            >
              {t("Back to Dashboard")}
            </Link>
          </>
        )
      ) : (
        <FadeLoader />
      )}
    </div>
  );
};

export default ConfirmOrder;
